<div class="card">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>Input</h4>
    </div>
  </div>

  <div class="card-body" style="height: auto;">
    <!-- Add margin-left to shift all inputs -->
    <div class="d-flex align-items-center gap-5" style="margin-left: 30px;">
      <div class="input-box">
        <label>Input 1</label>
        <input type="text" class="form-control" />
      </div>
      <div class="input-box">
        <label>Input 2</label>
        <input type="text" class="form-control" />
      </div>
      <div class="input-box">
        <label>Input 3</label>
        <input type="text" class="form-control" />
      </div>

      <button class="btn btn-primary ms-auto">
        Submit
      </button>
    </div>
  </div>
</div>
